import type { Frequency, SegmentStatement, StatementType } from '../../../types/processEdge';

export const helperTextByFrequency: Record<Frequency, string> = {
  daily: 'se ejecuta todos los días',
  weekly: 'se ejecuta una vez por semana',
  monthly: 'se ejecuta una vez por mes',
  adhoc: 'solo se ejecuta cuando surge la necesidad',
};

export const statementTypeOptions: Array<{
  type: StatementType;
  label: string;
  helper: string;
  group: 'Flujo' | 'Datos' | 'Integraciones' | 'Control';
}> = [
  { type: 'STEP', label: 'Step', helper: 'Movimiento entre nodos con acción principal.', group: 'Flujo' },
  { type: 'WAIT', label: 'Wait', helper: 'Pausa por tiempo o hasta que se cumpla una condición.', group: 'Flujo' },
  { type: 'ASSIGN', label: 'Assign', helper: 'Guarda o actualiza un valor en una variable.', group: 'Datos' },
  { type: 'CALL', label: 'Call', helper: 'Llama una función/servicio con argumentos.', group: 'Integraciones' },
  { type: 'TRIGGER', label: 'Trigger', helper: 'Dispara un evento para otro sistema.', group: 'Integraciones' },
  { type: 'ON', label: 'On', helper: 'Abre un bloque que se ejecuta al ocurrir un evento.', group: 'Control' },
  { type: 'EXCEPTION', label: 'Exception', helper: 'Abre manejo explícito de errores.', group: 'Control' },
];

export const normalizeStatement = (statement: SegmentStatement | undefined, from: string, to: string): SegmentStatement => {
  if (!statement) {
    return { type: 'STEP', from, to, action: '', sync: 'blocking', meta: {} };
  }
  return statement;
};

export const statementTypeToFlowType: Record<StatementType, 'normal' | 'branch' | 'loop' | 'fail' | 'parallel' | 'wait'> = {
  STEP: 'normal',
  ASSIGN: 'normal',
  CALL: 'normal',
  TRIGGER: 'normal',
  WAIT: 'wait',
  ON: 'branch',
  EXCEPTION: 'fail',
};
